import React from 'react';

import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import Button from '@asteria/component-core/button';

import * as ModalStore from '@asteria/datalayer/stores/modals';

import { useTranslationFn } from '@asteria/language/hooks';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps & { section: unknown, object: unknown }> } */
const RowClient = React.memo(function RowClient(props) {
	const { query, links } = props;

	const dispatch = useDispatch();
	const translate = useTranslationFn();

	const analytics = React.useMemo(
		() => ({ client: links.client }),
		[links.client],
	);

	const id = links?.client?._id ?? links?.client?.id;

	const handleClientClick = React.useCallback(() => {
		dispatch(
			ModalStore.open({
				type: ModalStore.MODAL_WINDOWS.ClientOverview,
				data: { _id: id },
			}),
		);
	}, [dispatch, id]);

	return (
		<Button
			label={translate('transaction.details.client.action', {
				default: '{{ client.name }}',
				data: {
					item: query?.data,
					...links,
					bank: links.bankTransaction,
				},
			})}
			variant="link"
			size="sm"
			onClick={handleClientClick}
			analytics={analytics}
			analyticsKey="transaction.details.client.click"
		/>
	);
});

RowClient.propTypes = {
	query: PropTypes.object,
	links: PropTypes.object,
};

export default RowClient;
